import MUIDataTable, { MUIDataTableOptions } from 'mui-datatables';
import { Fragment, useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { Button as ButtonMui, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import AnimatedCheckmark, { MODES } from 'react-animated-checkmark'
import axios from 'axios';
import { getHeaderForAxios, getUserData } from '../../common/getLocalStorageData';
import findMaxOrEqualDate from '../../common/findMaxOrEqualDate';
import { getTodayDate } from '../../common/dateFunction';
import { useSelector } from 'react-redux';
import { IReduxStateData } from '../../interfaces/redux';
import { PROFILE_WINNERHISTORY, SIDE_MENU_PROFILE } from '../../constant/menuAndProfile';
interface ICertificateList {
    // dealList: Array<any>,
    dealDetail: Array<any>,
    selectedDeal: any,
    winnerList: Array<any>,
    selectedSponsor: string,
    // changeActiveDeal: (arg0: string, arg1: string) => void,
    // changeDealData?: (arg0: Array<any>) => void,
    refreshData?: () => void,
    openSelectOption: (open: boolean) => void,
    changeWinnerData: (data: any) => void
}
interface IData {
    index?: number;
    user?: string;
    match_title?: string;
    tp_name?: string;
    award_value?: string;
    award_start_date?: string;
    award_end_date?: string;
    is_redeemed?: number;
    redeemed_by?: string;
}
export const CertificateListStore = (props: ICertificateList) => {
    const [results, setResults] = useState<IData[]>([]);
    const [finalData, setFinalData] = useState<(string | number | undefined)[][]>([]);
    const [currentDealDetail, setCurrentDealDetail] = useState<any>({})
    const [changeFlag, setFlag] = useState<boolean>(true)
    const [offerPin, setOfferPin] = useState("")
    const [lcdRedeemData, setLcdRedeemData] = useState<any>({})
    const [activeRedeemData, setActiveRedeemData] = useState<any>({})
    const [lcdRedeemResponse, setLcdRedeemResponse] = useState({
        type: "",
        message: ""
    })
    const [openRedeemLcdDialog, setOpenRedeemLcdDialog] = useState<boolean>(false)
    const [redeemFlag, setRedeemFlag] = useState<boolean>(true)
    const [mode, setMode] = useState(MODES.LOADING)
    const userId = getUserData();
    const globalState = useSelector((state: IReduxStateData) => state);
    const selectedLanguage = globalState?.selectedLang;
    const columns = [
        { name: PROFILE_WINNERHISTORY[selectedLanguage].no, options: { filter: false, fullWidth: true } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].user, options: { filter: false } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].match, options: { filter: true } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].team_player, options: { filter: true } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].offer, options: { filter: true } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].offer_from, options: { filter: false } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].offer_to, options: { filter: false } },
        {
            name: PROFILE_WINNERHISTORY[selectedLanguage].redeemed, options: {
                filter: true,
                customBodyRender: (value: any, tableMeta: { rowData: any; }, updateValue: any) => {
                    return (
                        <Fragment>
                            {value ? <FaCheck />
                                :
                                <FaTimes />
                            }
                        </Fragment>
                    );
                }
            }
        },
        {
            name: PROFILE_WINNERHISTORY[selectedLanguage].redeemed_by, options: { filter: true }
        },
        {
            name: PROFILE_WINNERHISTORY[selectedLanguage].action, options: {
                filter: true,
                customBodyRender: (value: any, tableMeta: { rowData: any; }, updateValue: any) => {
                    return (
                        <Fragment>
                            {value?.redeemed === 0 ?
                                <ButtonMui variant="contained" onClick={() => {
                                    if (value.hasOwnProperty('itemNo') && props?.winnerList) {
                                        const indexNo = value['itemNo'];
                                        const dataFin = props.winnerList?.[indexNo]
                                        if (dataFin) {
                                            setLcdRedeemData({
                                                code: dataFin?.winner_award_code,
                                                alphacode_uuid: dataFin?.alphacode_uuid
                                            })
                                            setActiveRedeemData(dataFin)
                                        } else {
                                            setLcdRedeemData({})
                                            setActiveRedeemData({})
                                        }
                                    }
                                    setOpenRedeemLcdDialog(true)
                                    setRedeemFlag(!redeemFlag)
                                }
                                }>Redeem</ButtonMui>
                                : <FaTimes />
                            }
                        </Fragment>
                    );
                }
            }
        }
    ];
    const options: MUIDataTableOptions = {
        filter: true,
        filterType: "dropdown",
        responsive: 'simple',
        jumpToPage: true,
        fixedSelectColumn: false,
        fixedHeader: false,
        pagination: true,
        selectableRows: 'none', // used to hide selction of rows
        rowsPerPageOptions: [100, 200, 300, 400],
        rowsPerPage: 100,
        // search: true,
        // download: true,
        // print: true,
        // viewColumns: true,
        // filter: true,
        // filterType: "dropdown",
        // responsive: "vertical",
        onTableChange: (action, state) => {
            console.log(action);
            console.dir(state);
        }
    };
    useEffect(() => {
        if (props.winnerList) {
            let data: any[] = [];
            let array: (string | number | undefined)[][];
            // eslint-disable-next-line array-callback-return
            props?.winnerList?.map((winnerData: any, index: number) => {
                data.push({
                    index: index + 1,
                    user: winnerData?.user_name,
                    match_title: winnerData?.match_title,
                    tp_name: winnerData?.tp_name,
                    award_value: winnerData?.award_value,
                    award_start_date: new Date(winnerData?.award_start_date).toLocaleTimeString() + " " + new Date(winnerData?.award_start_date).toLocaleDateString(),
                    award_end_date: new Date(winnerData?.award_end_date).toLocaleTimeString() + " " + new Date(winnerData?.award_end_date).toLocaleDateString(),
                    is_redeemed: winnerData?.is_redeemed,
                    redeemed_by: winnerData?.redeemed_by,
                    ActionRedeem: { redeemed: winnerData?.is_redeemed, itemNo: index }
                })
            })
            setResults(data)
            if (data) {
                if (data.length) {
                    array = data?.map(result => [result.index, result.user, result.match_title || "", result.tp_name || '', result?.award_value || '', result?.award_start_date || "", result?.award_end_date || "", result?.is_redeemed || "", result?.redeemed_by, result?.ActionRedeem]);
                    // data = array;
                    setFinalData(array)
                } else {
                    setFinalData([])
                }
            }
        }
        setFlag(!changeFlag)
    }, [props.winnerList])
    useEffect(() => {
        if (props?.dealDetail && props?.selectedDeal) {
            props?.dealDetail?.forEach((dData: any) => {
                if (dData?.uuid === props?.selectedDeal) {
                    setCurrentDealDetail(dData)
                    setFlag(!changeFlag)
                }
            })
        }
    }, [props?.dealDetail, props?.dealDetail.length, props?.selectedDeal])

    const popupResetAndClose = () => {
        setMode(MODES.LOADING)
        setOfferPin("")
        setLcdRedeemData({})
        setOpenRedeemLcdDialog(false)
        setRedeemFlag(!redeemFlag)
        setLcdRedeemResponse({ type: "", message: "" })
        setActiveRedeemData({})
    }

    const onSaveRedeem = async () => {
        const currentTime = getTodayDate();
        const offerExpireOrNotStart = !(findMaxOrEqualDate(activeRedeemData?.award_start_date, currentTime) === 2 && findMaxOrEqualDate(activeRedeemData?.award_end_date, currentTime) === 1)
        if (offerExpireOrNotStart) {
            setLcdRedeemResponse({ type: 'error', message: "Offer is already expired or  still not started Please contanct sponsor." })
            setRedeemFlag(!redeemFlag)
        } else {
            if (offerPin) {
                const finalData = { ...lcdRedeemData, user_uuid: userId, pin: offerPin }
                await axios.post(process.env.REACT_APP_API_URL + "/store/setRedeemedOffer", finalData, { headers: getHeaderForAxios() })
                    .then(function (response) {
                        setLcdRedeemResponse({ type: "success", message: response?.data?.message })
                        setTimeout(() => {
                            setMode(MODES.SUCCESS)
                        }, 1500);
                        setTimeout(() => {
                            props.changeWinnerData(activeRedeemData)
                            popupResetAndClose()
                        }, 3000);

                    })
                    .catch(function (error) {
                        if (error.response?.data?.message) {
                            setLcdRedeemResponse({ type: error.response?.data?.status, message: error.response?.data?.message })
                            setRedeemFlag(!redeemFlag)
                            setTimeout(() => {
                                setLcdRedeemResponse({ type: "", message: "" })
                            }, 3000)
                        }
                    })
            }
        }
    }

    const addDashInCode = (item) => {
        return item.toString().replace(/.{1,4}(?=(.{4})+$)/g, '$&-')
    }

    return (
        <Fragment key={changeFlag ? "true" : "false"}>
            <div className='right-side-header-main'>
                <div className='right-side-header'>{PROFILE_WINNERHISTORY[selectedLanguage].winner_history}
                    <div className="material-dropdown-select header-toggle-button">
                        <Button
                            onClick={() => { props.openSelectOption(true) }}
                            variant="primary" className='btn btn-dark theme-background-dark-black theme-white rounded-sm py-2 font-16' autoFocus>
                            {PROFILE_WINNERHISTORY[selectedLanguage].toggle_data}
                        </Button>
                    </div >
                </div>
            </div>
            <hr />
            <Dialog
                open={openRedeemLcdDialog}
                onClose={() => { popupResetAndClose() }}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle className='d-flex align-self-center justify-content-center'>
                    {PROFILE_WINNERHISTORY[selectedLanguage].dialog_redeemed_offer}
                </DialogTitle>
                <DialogContent
                    key={redeemFlag ? "true" : "false"}
                >
                    <Row className='mx-5'>
                        <Col sm={12} className=''>
                            {lcdRedeemResponse.message ? (
                                <div
                                    className={"text-center mb-1 " +
                                        (lcdRedeemResponse.type === "success"
                                            ? "form-response success"
                                            : "form-response error")
                                    }
                                >
                                    {lcdRedeemResponse.message}
                                </div>
                            ) : null}
                            {openRedeemLcdDialog ?
                                !(lcdRedeemResponse?.message) || (lcdRedeemResponse.type === "error") ?
                                    <Fragment>
                                        <Row>
                                            <TextField
                                                fullWidth
                                                margin="dense"
                                                variant="outlined"
                                                label={PROFILE_WINNERHISTORY[selectedLanguage].dialog_redeemed_offer_code}
                                                id="pac-offer-code"
                                                value={addDashInCode(lcdRedeemData?.code || "")}
                                                disabled
                                            />
                                        </Row>
                                        <Row>
                                            <TextField
                                                fullWidth
                                                margin="dense"
                                                variant="outlined"
                                                label={PROFILE_WINNERHISTORY[selectedLanguage].dialog_redeemed_offer_pin}
                                                id="pac-offer-pin"
                                                type="number"
                                                InputProps={{ inputProps: { max: 9999 } }}
                                                value={offerPin}
                                                defaultValue={offerPin}
                                                onChange={(e) => setOfferPin(e.target.value)}
                                            />
                                        </Row>
                                    </Fragment>
                                    :
                                    <div className='w-100 text-center'>
                                        <AnimatedCheckmark mode={mode} breathingCollapse={true} />
                                    </div>
                                : null}
                            {/* </Row> */}
                        </Col>
                    </Row>
                </DialogContent>
                <DialogActions>
                    <Row className='mx-5 mb-2 w-100 d-flex align-self-center justify-content-center'>
                        <Button
                            onClick={onSaveRedeem}
                            variant="dark" className='py-1 rounded-sm' autoFocus>
                            {SIDE_MENU_PROFILE[selectedLanguage].save}
                        </Button>
                        <Button
                            onClick={() => { popupResetAndClose() }}
                            variant="primary" className='ml-2 py-1 rounded-sm' autoFocus>
                            {SIDE_MENU_PROFILE[selectedLanguage].close}
                        </Button>
                    </Row>
                </DialogActions>
            </Dialog>
            {/* <Row>
                <Col sm={12} className="d-flex align-items-center justify-content-end">
                    <div className="material-dropdown-select">
                        <Button
                            onClick={() => { props.openSelectOption(true) }}
                            variant="primary" className='btn btn-dark theme-background-dark-black theme-white rounded-sm py-2 font-16' autoFocus>
                            Toggle Data
                        </Button>
                    </div >
                </Col>
            </Row> */}
            {/* <Row>
                <Col sm={5} lg={4} className='card-column theme-background-green m-0 theme-border-green'>
                    {currentDealDetail ?
                        <Fragment>
                            <img className='card-img theme-background-dark-green py-4 px-2' alt='' src={(currentDealDetail.is_player ? currentDealDetail.player_image : currentDealDetail.team_logo) || '/assets/images/player-banner.png'} />
                            <div className='card-image-overlay'>
                                <div>
                                    <span className='image-wrapper'>
                                        <img className='image-rank' alt='' src='/assets/images/team-rank.svg' />
                                        <span className='image-rank-number'>1</span>
                                    </span>
                                    <span className='image-team-wrapper'>
                                        <img alt='' className='team-name' src='/assets/images/team-name.svg' />
                                        <span className='team-name-title theme-white'>{(currentDealDetail.is_player ? currentDealDetail.player_name : currentDealDetail.team_name) || currentDealDetail.tp_name}</span>
                                    </span>
                                </div>
                                <div className='image-card-title'>
                                    <span className={`image-card-wrapper ${!currentDealDetail.is_player || (currentDealDetail.is_player && !currentDealDetail.player_jersey_number) ? 'bottom' : ''}`}>
                                        <img alt='' className='image-title' src='/assets/images/team-name.svg' />
                                        <span className='image-title-name theme-white'>{currentDealDetail?.match_title}</span>
                                    </span>
                                    {currentDealDetail.is_player && currentDealDetail.player_jersey_number ?
                                        <span className='image-circle-wrapper'>
                                            <img alt='' src='/assets/images/circle.svg' className='image-circle' />
                                            <span className='circle'>{currentDealDetail.player_jersey_number}</span>
                                        </span>
                                        : null}
                                </div>
                            </div>
                        </Fragment>
                        : null}
                </Col>
                <Col sm={7} lg={5} className="d-flex align-items-center justify-content-center pl-0">
                    <div className='beside-image'>
                        {currentDealDetail?.is_player ?
                            <Fragment>
                                <div className="d-flex bd-highlight">
                                    <div className="p-1 w-50 bd-highlight">Name :</div>
                                    <div className="p-1 theme-green text-capitalize">{currentDealDetail?.player_name}</div>
                                </div>
                                <div className="d-flex bd-highlight">
                                    <div className="p-1 w-50 bd-highlight">Birth Place :</div>
                                    <div className="p-1 theme-green text-capitalize">{currentDealDetail?.player_birth_place}</div>
                                </div>
                                <div className="d-flex bd-highlight">
                                    <div className="p-1 w-50 bd-highlight">Birth Date :</div>
                                    <div className="p-1 theme-green">{currentDealDetail?.player_date_of_birth ? new Date(currentDealDetail?.player_date_of_birth).toLocaleDateString() : ""}</div>
                                </div>
                                <div className="d-flex bd-highlight">
                                    <div className="p-1 w-50 bd-highlight">Postion :</div>
                                    <div className="p-1 theme-green text-capitalize">{currentDealDetail?.player_position}</div>
                                </div>
                            </Fragment>
                            : <Fragment>
                                <div className="d-flex bd-highlight">
                                    <div className="p-1 w-50 bd-highlight">Name :</div>
                                    <div className="p-1 theme-green text-capitalize">{currentDealDetail?.team_name}</div>
                                </div>
                                <div className="d-flex bd-highlight">
                                    <div className="p-1 w-50 bd-highlight">Full Name :</div>
                                    <div className="p-1 theme-green text-capitalize">{currentDealDetail?.team_fullname}</div>
                                </div>
                                <div className="d-flex bd-highlight">
                                    <div className="p-1 w-50 bd-highlight">Nationality :</div>
                                    <div className="p-1 theme-green text-capitalize">{currentDealDetail?.team_flag ? <img src={currentDealDetail.team_flag} alt="" /> : ""}</div>
                                </div>
                                <div className="d-flex bd-highlight">
                                    <div className="p-1 w-50 bd-highlight">Owner :</div>
                                    <div className="p-1 theme-green text-capitalize">{currentDealDetail?.team_owner}</div>
                                </div>
                            </Fragment>
                        }
                        <div className="d-flex bd-highlight">
                            <div className="p-1 w-50 bd-highlight">League :</div>
                            <div className="p-1 theme-green text-capitalize">{currentDealDetail?.league_name}</div>
                        </div>
                    </div>
                </Col>
            </Row> */}
            <Row className='pt-2'>
                <Col sm={12} className='react-table-kitchen-wrapper theme-dark-black'>
                    <div className="table-wrapper" key={changeFlag ? "true" : "false"} style={{ 'flexGrow': 1 }}>
                        {finalData ?
                            // <ThemeProvider theme={createTheme()}>
                            <MUIDataTable
                                title={(props?.selectedSponsor ? props?.selectedSponsor + " - " : "") + (currentDealDetail?.match_title || "")}
                                data={finalData}
                                columns={columns}
                                options={options}
                            />
                            // </ThemeProvider>
                            : null
                        }
                    </div>
                </Col>
            </Row>
        </Fragment>
    )
}
